<template>
  <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-form lazy-validation ref="form" v-model="form.valid">
            <v-row dense justify="center">
              <v-col cols="11">
                <v-text-field required v-model="form.title"
                  label="滞在先名"
                  :rules="rules.title"></v-text-field>
              </v-col>
              <v-col cols="11">
                <v-combobox required v-model="form.type"
                  label="宿泊タイプ"
                  :items="getTypeItems"
                  :rules="rules.type"></v-combobox>
              </v-col>
              <v-col cols="11" sm="5">
                <v-menu offset-y full-width
                  v-model="config.datepicker.start"
                  transition="scale-transition"
                  min-width="290px"
                  :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-text-field readonly
                      v-on="on"
                      v-model="printFormatedStartDate"
                      label="開始日"
                    />
                  </template>
                  <v-date-picker
                    v-model="form.dates.start"
                    color="amber"
                    locale="ja"
                    :day-format="date => new Date(date).getUTCDate()"
                    @input="config.datepicker.start = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="1" v-if="$vuetify.breakpoint.smAndUp" align-self="center">&mdash;</v-col>
              <v-col cols="11" sm="5">
                <v-menu offset-y full-width
                  v-model="config.datepicker.end"
                  transition="scale-transition"
                  min-width="290px"
                  :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-text-field readonly
                      v-on="on"
                      v-model="printFormatedEndDate"
                      label="終了日"
                    />
                  </template>
                  <v-date-picker
                    v-model="form.dates.end"
                    color="amber"
                    locale="ja"
                    :day-format="date => new Date(date).getUTCDate()"
                    @input="config.datepicker.end = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="2">
                <v-combobox v-model="form.term.size"
                  :items="getTermSizeItems"
                  label="期間数"
                />
              </v-col>
              <v-col cols="3">
                <v-combobox v-model="form.term.unit"
                  :items="getTermUnitItems"
                  label="単位"
                />
              </v-col>
              <v-col align-self="center" cols="11" sm="1">＋</v-col>
              <v-col cols="2">
                <v-combobox v-model="form.extra.size"
                  :items="getTermSizeItems"
                  label="期間数"
                />
              </v-col>
              <v-col cols="3">
                <v-combobox v-model="form.extra.unit"
                  :items="getTermUnitItems"
                  label="単位"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit">{{ (form.id && isFinite(form.id)) ? '保存する' : '追加する' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'insertModalProgram',
  data () {
    return {
      config: {
        status: {
          active: false
        },
        datepicker: {
          start: false,
          end: false
        }
      },
      meta: {
        types: [
          '個室食事なし',
          '個室３食付',
          '個室朝食付',
          '個室夕食付',
          '個室朝夕食付',
          '２人部屋食事なし',
          '２人部屋３食付',
          '２人部屋朝食付',
          '２人部屋夕食付',
          '２人部屋朝夕食付',
          '３人部屋食事なし',
          '３人部屋３食付',
          '３人部屋朝食付',
          '３人部屋夕食付',
          '３人部屋朝夕食付',
          '４人部屋食事なし',
          '４人部屋３食付',
          '４人部屋朝食付',
          '４人部屋夕食付',
          '４人部屋朝夕食付',
          '５人部屋食事なし',
          '５人部屋３食付',
          '５人部屋朝食付',
          '５人部屋夕食付',
          '５人部屋朝夕食付',
          '６人部屋食事なし',
          '６人部屋３食付',
          '６人部屋朝食付',
          '６人部屋夕食付',
          '６人部屋朝夕食付'
        ],
        term: {
          size: new Array(100).fill(null).map((_, i) => (i + 1)),
          units: [
            '週',
            '日',
            'ヶ月',
            'ターム',
            'セクション'
          ]
        }
      },
      form: {
        valid: true,
        id: '',
        title: '',
        type: '',
        dates: {
          start: '',
          end: ''
        },
        term: {
          size: '',
          unit: ''
        },
        extra: {
          size: '',
          unit: ''
        }
      },
      rules: {
        title: [ v => !!v || '必須項目です' ],
        type: [ v => !!v || '必須項目です' ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$emit('done', {
          type: 'stays',
          data: JSON.parse(JSON.stringify(this.form))
        })
        this.close()
      }
    },
    open: function (values) {
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', values ? {
        valid: true,
        id: values.id ? values.id : ('stay_' + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)),
        title: values.title ? values.title : '',
        type: values.type ? values.type : '',
        dates: {
          start: (values.dates && values.dates.start) ? values.dates.start : '',
          end: (values.dates && values.dates.end) ? values.dates.end : ''
        },
        term: {
          size: (values.term && values.term.size) ? values.term.size : '',
          unit: (values.term && values.term.unit) ? values.term.unit : ''
        },
        extra: {
          size: (values.extra && values.extra.size) ? values.extra.size : '',
          unit: (values.extra && values.extra.unit) ? values.extra.unit : ''
        }
      } : {
        valid: true,
        id: ('stay_' + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)),
        title: '',
        type: '',
        dates: {
          start: '',
          end: ''
        },
        term: {
          size: '',
          unit: ''
        },
        extra: {
          size: '',
          unit: ''
        }
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    printFormatedStartDate () {
      return (
        this.form &&
        this.form.dates &&
        this.form.dates.start
      ) ? this.$moment(this.form.dates.start).format('YYYY/MM/DD') : ''
    },
    printFormatedEndDate () {
      return (
        this.form &&
        this.form.dates &&
        this.form.dates.end
      ) ? this.$moment(this.form.dates.end).format('YYYY/MM/DD') : ''
    },
    getTypeItems () {
      return this.meta.types
    },
    getTermSizeItems () {
      return this.meta.term.size
    },
    getTermUnitItems () {
      return this.meta.term.units
    }
  }
}
</script>
